import { Provider } from "react-redux";
import Cart from "./components/Cart";
import store from "./redux/store";


export default function App() {


    return (
        <Provider store={store}>
            <Cart />
        </Provider>
    );
}
